import {Action} from "redux";
import {QueryId} from "./data";
import {CategoryId} from "../../lib/category-manager/data";

export type QueriesWidgetAction = SetCategoryFiltersAction
	| SetQueryCheckboxAction
	| UnsetQueryCheckboxAction

type SetCategoryFiltersAction = {
	type: 'set category filters'
	categories: CategoryId[]
}

type SetQueryCheckboxAction = {
	type: 'set query checkbox'
	query: QueryId
}

type UnsetQueryCheckboxAction = {
	type: 'unset query checkbox'
	query: QueryId
}

export type QueriesWidgetActionWrapper = {
	type: 'queries widget action'
	action: QueriesWidgetAction
}

export const isQueriesWidgetAction = (a: Action): a is QueriesWidgetActionWrapper => a.type == 'queries widget action'



// WEBPACK FOOTER //
// ./src/communications/queries-widget/actions.ts